'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, Suspense } from 'react'
import { capturePageview } from '../lib/posthog'

function PostHogPageviewInner() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!pathname) return

    let url = window.origin + pathname
    if (searchParams?.toString()) {
      url = url + '?' + searchParams.toString()
    }

    void capturePageview(url)
  }, [pathname, searchParams])

  return null
}

export default function PostHogPageview() {
  return (
    <Suspense fallback={null}>
      <PostHogPageviewInner />
    </Suspense>
  )
}
